import React, { useContext } from 'react';
import { Col, Form, Input, Radio, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import { EnrollmentFormContext } from '../../../../../../../../../../providers/EnrollmentFormContextProvider';
import useParams from '../../../../../../../../../params/useParams';
import paramEndpoints from '../../../../../../../../../params/paramEndpoints';
import IdentificationType from '../../../../../../../../../../enums/identificationType';

const UAFLegalBackgroundForm = ({ gutter }) => {
  const [societyTypes, areSocietyTypesLoading] = useParams(paramEndpoints.SOCIETY_TYPES);

  const { enrollmentForm } = useContext(EnrollmentFormContext);

  const mainLegalRepresentativeIndex = enrollmentForm
    .getFieldValue('legalRepresentatives')
    ?.findIndex(({ isTheMainRepresentative }) => isTheMainRepresentative);

  return (
    <>
      <Row justify="start" gutter={[gutter]}>
        <Col className="declaringPersonForm__title" span={24}>
          Antecedentes Representante Legal
        </Col>
      </Row>
      <Row gutter={[gutter]}>
        <Col lg={12} xs={24}>
          <Form.Item
            name={['legalRepresentatives', mainLegalRepresentativeIndex, 'identificationType']}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Radio.Group>
              <Radio value={IdentificationType.RUT} disabled>
                RUT
              </Radio>
              <Radio value={IdentificationType.PASAPORTE} disabled>
                Pasaporte
              </Radio>
              <Radio value={IdentificationType.OTRO} disabled>
                Otro
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[gutter]}>
        <Col lg={12} xs={24}>
          <Form.Item
            label="Nº de Identificación"
            name={['legalRepresentatives', mainLegalRepresentativeIndex, 'identification']}
            rules={[
              {
                required: true,
                message: 'Nombre es requerido',
              },
            ]}
          >
            <Input disabled />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[gutter]}>
        <Col span={24}>
          <Form.Item
            label="Nombre"
            name={['legalRepresentatives', mainLegalRepresentativeIndex, 'name']}
            rules={[
              {
                required: true,
                message: 'Dato requerido',
              },
            ]}
          >
            <Input disabled />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[gutter]}>
        <Col lg={12} xs={24}>
          <Form.Item
            label="Apellido Paterno"
            name={['legalRepresentatives', mainLegalRepresentativeIndex, 'firstSurname']}
            rules={[
              {
                required: true,
                message: 'Dato requerido',
              },
            ]}
          >
            <Input disabled />
          </Form.Item>
        </Col>
        <Col lg={12} xs={24}>
          <Form.Item
            label="Apellido Materno"
            name={['legalRepresentatives', mainLegalRepresentativeIndex, 'secondSurname']}
            rules={[
              {
                required: false
              },
            ]}
          >
            <Input disabled />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[gutter]}>
        <Col lg={12} xs={24}>
          <Form.Item
            label="Tipo de Sociedad"
            name={['legalRepresentatives', mainLegalRepresentativeIndex, 'societyType']}
            rules={[
              {
                required: true,
                message: 'Dato requerido',
              },
            ]}
          >
            <Select loading={areSocietyTypesLoading} disabled={areSocietyTypesLoading}>
              {societyTypes.map((societyType) => (
                <Select.Option id={societyType.id} value={societyType.id}>
                  {societyType.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

UAFLegalBackgroundForm.propTypes = {
  gutter: PropTypes.number.isRequired,
};

export default UAFLegalBackgroundForm;
